import axiosInstance from '../../../config/axiosInstance';
const QuotationService = {
    async GetAllQuotations(redirectCallback, ClientCompanyID, LeadID, OpportunityID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Quotation/GetAllQuotations?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&LeadID=${LeadID}&OpportunityID=${OpportunityID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllNewQuotations(redirectCallback, ClientCompanyID, LeadID, OpportunityID, Start, PageSize, searchQuery, sortColumn, sortDirection,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Quotation/GetAllNewQuotations?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&LeadID=${LeadID}&OpportunityID=${OpportunityID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetQuotationCount(redirectCallback, ClientCompanyID, LeadID, OpportunityID, searchQuery,SearchColumns) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
             const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Quotation/GetQuotationCount?ClientID=${ClientID}&ClientCompanyID=${ClientCompanyID}&LeadID=${LeadID}&OpportunityID=${OpportunityID}&searchQuery=${searchQuery}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllParts(redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, CustomerID = 0, SearchColumns) {
        try {

            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Quotation/GetParts?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&CustomerID=${CustomerID}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetQuotationByID(redirectCallback, ID, CustomerType = 1) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Quotation/GetQuotationByID?ID=${ID}&CustomerType=${CustomerType}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async GetQuotationItem(redirectCallback, ID, CustomerType = 1) {
        try {
            debugger;
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Quotation/GetQuotationItem?ID=${ID}&CustomerType=${CustomerType}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },

    async DeleteQuotation(ID, typeOfCustomer, redirectCallback) {
        try {
            const idString = ID.join(',');
            const response = await axiosInstance.get(`/Quotation/DeleteQuotation?ID=${idString}&type=${typeOfCustomer}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetJobNo(ID, IssueID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Quotation/SetJobNo?ID=${ID}&IssueID=${IssueID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetSaleOrderNo(ID, SaleOrderID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Quotation/SetSaleOrderNo?ID=${ID}&SaleOrderID=${SaleOrderID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetInvoiceNo(ID, InvoiceID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Quotation/SetInvoiceNo?ID=${ID}&InvoiceID=${InvoiceID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UpdateQuotationConvertType(PK_Quotation_ID, ConvertType) {
        try {
            const response = await axiosInstance.get(`/Quotation/UpdateQuotationConvertType?PK_Quotation_ID=${PK_Quotation_ID}&ConvertType=${ConvertType}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async LockQuotation(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Quotation/LockQuotation?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async UnLockQuotation(ID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Quotation/UnLockQuotation?ID=${ID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async RestoreClient(CustomerID) {
        try {
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Customer/RestoreClient?CustomerID=${CustomerID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
};

export default QuotationService;